module.exports = __webpack_public_path__ + "img/fanboshi.5d1cdd24.png";